import {GET_ALL_LOANS} from "../../constant/ActionType";

export default function LoansAllReducer(state = {
    loansData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case GET_ALL_LOANS:
			return { ...state,
				loansData: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}

